import { isAsset, isExtensions, isImpl, isProperty, isTile, } from "./index";
import { Matrix4 } from "three";
/**
 * This function will walk the tile tree and default initialize all tiles with an empty extras object. If one already
 * exists we will overwrite it.
 *
 * The function returns a reference to the input tileset with a more refined type, making subsequent uses of the extras
 * easier.
 */
export function initExtras(tileset, owner) {
    // Cast the input tileset to the new type and add the missing field to make the type correct
    const tilesetWithMeta = tileset;
    tilesetWithMeta.extras.owner = owner;
    // Initialize the node stack. The stack pairs the parent's refinement mode with one of the parent's child nodes.
    const nodeStack = [tilesetWithMeta.root];
    // Keep processing nodes until we run out of work to do
    while (nodeStack.length > 0) {
        // Cast the metadata to 'any' as the type is being changed
        const node = nodeStack.pop();
        // Create our metadata object and assign it to extras, making this a Tile<TileMetadataObject>
        // noinspection UnnecessaryLocalVariableJS
        const metadata = {
            // The tileset will be the correct type once this function returns
            owner: tilesetWithMeta,
            // Default to identity matrix
            transform: new Matrix4(),
            // Default to empty content
            content: {},
        };
        node.extras = metadata;
        // Add the current node's children to the queue
        if (typeof node.children !== "undefined" && node.children !== null) {
            nodeStack.push(...node.children);
        }
    }
    // This function's job is to set up the object to match this type. This cast is correct, if the object doesn't match
    // the interface then it is a bug.
    return tileset;
}
/**
 * Returns whether obj matches the Tileset interface
 * @param obj
 */
export function isTileset(obj) {
    if (obj === null)
        return false;
    if (typeof obj !== "object")
        return false;
    if (!isAsset(obj.asset))
        return false;
    if (typeof obj.properties !== "undefined" && obj.properties !== null) {
        if (typeof obj.properties !== "object")
            return false;
        for (const prop of Object.values(obj.properties)) {
            if (!isProperty(prop))
                return false;
        }
    }
    if (typeof obj.geometricError !== "number")
        return false;
    if (!isTile(obj.root))
        return false;
    if (typeof obj.extensionsUsed !== "undefined" && obj.extensionsUsed !== null) {
        if (!Array.isArray(obj.extensionsUsed))
            return false;
        for (const e of obj.extensionsUsed) {
            if (typeof e !== "string")
                return false;
        }
    }
    if (typeof obj.extensionsRequired !== "undefined" && obj.extensionsRequired !== null) {
        if (!Array.isArray(obj.extensionsRequired))
            return false;
        for (const e of obj.extensionsRequired) {
            if (typeof e !== "string")
                return false;
        }
    }
    if (typeof obj.extensions !== "undefined" && obj.extensions !== null) {
        if (!isExtensions(obj.extensions))
            return false;
    }
    if (typeof obj.impl !== "undefined") {
        if (!isImpl(obj.impl))
            return false;
    }
    return true;
}
